export enum ApiError {
    Insucesso = -1,

    SMSNaoEncontrado = -2,

    DadosInvalidos = 0,

    Sucesso = 1,

    DocumentoValidoPessoaExisteCadastro = 2,

    DocumentoValidoPessoaCorrentista = 3,

    FalhaNaAutenticacao = 4,

    TokenExpirado = 5,

    TipoDeConcessaoErrado = 6,

    UsuarioBloqueioTemporario = 7,

    ChaveInvalida = 8,

    ContaInvalida = 9,

    PessoaInvalida = 10,

    PessoaBloqueada = 11,

    CriterioDeSenhaAceito = 12,

    CriterioDeSenhaNaoAceito = 13,

    InformaçãoNaoEncontrada = 14,

    ParametroInvalido = 15,

    CEPInvalido = 16,

    ConviteInvalido = 17,

    EstabelecimentoAguardandoAnalise = 18,

    ServicoNaoConfigurado = 50,

    ExtensaoDeAnexoNaoExistente = 51,

    ColaboradorTemQRCodeNestaCedente = 70,

    ColaboradorTemQRCodeOutraCedente = 71,

    ValidacaoModel = 400,

    ErroDeSistema = 999,

    PedidoArquivoColaboradoresNaoCadastrados = 61,
    PedidoArquivoCentrosCustoNaoCadastrados = 62,
    PedidoArquivoDepartamentosNaoCadastrados = 63,
    PedidoArquivoUnidadesNaoCadastradas = 64,
}
